var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "loader" } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }